{
  "expo": {
    "name": "MyTenue",
    "slug": "outfit-app",
    "version": "1.14.6",
    "orientation": "portrait",
    "icon": "./assets/icon.png",
    "userInterfaceStyle": "light",
    "assetBundlePatterns": [
      "**/*"
    ],
    "scheme": "outfit",
    "ios": {
      "supportsTablet": false,
      "bundleIdentifier": "com.outfitapp.mobile",
      "buildNumber": "206",
      "usesAppleSignIn": true,
      "infoPlist": {
        "ITSAppUsesNonExemptEncryption": false,
        "CFBundleDevelopmentRegion": "en",
        "NSPhotoLibraryUsageDescription": "MyTenue accesses your photos to add items to your wardrobe.",
        "NSCameraUsageDescription": "MyTenue uses the camera to take photos of your items.",
        "NSLocationWhenInUseUsageDescription": "MyTenue uses your location to show local weather and tailor outfit suggestions."
      }
    },
    "android": {
      "adaptiveIcon": {
        "foregroundImage": "./assets/adaptive-icon.png",
        "backgroundColor": "#9B7B5A"
      },
      "package": "com.outfitapp.mobile",
      "versionCode": 204,
      "softwareKeyboardLayoutMode": "resize",
      "permissions": [
        "READ_MEDIA_IMAGES",
        "READ_EXTERNAL_STORAGE",
        "CAMERA",
        "ACCESS_COARSE_LOCATION",
        "ACCESS_FINE_LOCATION",
        "com.google.android.gms.permission.AD_ID"
      ]
    },
    "web": {
      "favicon": "./assets/favicon.png"
    },
    "plugins": [
      [
        "expo-build-properties",
        {
          "ios": {
            "useFrameworks": "static"
          }
        }
      ],
      "@react-native-firebase/app",
      "@react-native-firebase/analytics",
      "expo-apple-authentication",
      "expo-image",
      "expo-localization",
      "expo-secure-store",
      [
        "expo-notifications",
        {
          "color": "#D4AF72"
        }
      ],
      [
        "expo-location",
        {
          "locationAlwaysAndWhenInUsePermission": "MyTenue uses your location to show local weather and tailor outfit suggestions."
        }
      ],
      "./plugins/withLocalizedPermissions.js"
    ],
    "extra": {
      "eas": {
        "projectId": "d8e2b72c-784c-41f5-b0ed-06e1e1bed45e"
      }
    },
    "runtimeVersion": "1.0.0",
    "updates": {
      "url": "https://u.expo.dev/d8e2b72c-784c-41f5-b0ed-06e1e1bed45e",
      "enabled": true,
      "checkAutomatically": "ON_LOAD",
      "fallbackToCacheTimeout": 3000
    }
  }
}
